import { render, staticRenderFns } from "./detailDrvLeft.vue?vue&type=template&id=865f8d22&scoped=true"
import script from "./detailDrvLeft.vue?vue&type=script&lang=js"
export * from "./detailDrvLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865f8d22",
  null
  
)

export default component.exports